import classNames from 'classnames';

import styles from './index.less';

export interface ModalTitleProps {
  className?: string;
  title: string;
  icon?: string;
}

export default function ModalTitle(props: ModalTitleProps): JSX.Element {
  const { className, title, icon } = props;

  return (
    <div className={classNames(styles.headerContainer, className)}>
      {icon && <img className={styles.icon} src={icon} />}
      <span>{title}</span>
    </div>
  );
}
